import React, { useMemo } from 'react';
import type { DataTableRenderCellParams } from '@/components/custom/erp/data-table-v2';
import { ErpInputTableV2 } from '@/components/custom/erp';
import { getTableColumns } from './columns';
import { SelectedCellInfo } from '../hooks';
import { FormMode } from '@/types/form';

interface ChiPhiChiTietTabProps {
  formMode: FormMode;
  rows: { uuid?: string | null }[];
  selectedRowUuid?: string | null;
  selectedCell?: SelectedCellInfo | null;
  onRowClick?: (params: MuaHangRecord) => void;
  onCellClick?: (params: DataTableRenderCellParams) => void;
  onAddRow: () => void;
  onDeleteRow: () => void;
  onCopyRow: () => void;
  onPasteRow: () => void;
  onMoveRow: (direction: 'up' | 'down') => void;
  onCellValueChange: (rowUuid: string, field: string, newValue: MuaHangRecord) => void;
}

export const ChiPhiChiTietTab: React.FC<ChiPhiChiTietTabProps> = ({
  formMode,
  rows,
  selectedRowUuid,
  onRowClick,
  onAddRow,
  onDeleteRow,
  onCopyRow,
  onPasteRow,
  onMoveRow,
  onCellValueChange
}) => {
  const columns = useMemo(() => getTableColumns(onCellValueChange, formMode), [formMode, onCellValueChange]);

  return (
    <ErpInputTableV2
      rows={rows}
      autoHeight
      showIndexColumn
      bottomSelector='[data-arito-bottom-bar]'
      onRowClick={onRowClick}
      selectedRowId={selectedRowUuid || undefined}
      columns={columns}
      getRowId={row => row?.uuid || ''}
      actionsDisabled={formMode === 'view'}
      actionOrder={[
        'add',
        'delete',
        'copy',
        'paste',
        'moveUp',
        'moveDown',
        'export',
        'pin',
        'viewInventory',
        'viewReceipt'
      ]}
      actions={{
        add: onAddRow,
        delete: onDeleteRow,
        copy: onCopyRow,
        paste: onPasteRow,
        moveUp: () => onMoveRow('up'),
        moveDown: () => onMoveRow('down'),
        export: () => console.log('Export clicked'),
        pin: () => console.log('Pin clicked'),
        viewInventory: () => console.log('View inventory clicked'),
        viewReceipt: () => console.log('View receipt clicked')
      }}
    />
  );
};
